<div class="tw:w-full tw:px-[15px] tw:mx-auto tw:min-h-full tw:flex">
  <form [formGroup]="frmGroupMaintenance" class="tw:flex tw:flex-col tw:flex-1 tw:min-h-full">
    <div class="tw:flex tw:flex-col tw:-mx-[15px] tw:flex-1">

      <div class="tw:w-full tw:px-[15px]">
        <h3 class="tw:mb-1">{{themeService.siteContent.maintenanceBookingRefLabel}} {{placementId}}</h3>
        <p class="tw:text-sm tw:text-gray-600 tw:mb-0">{{clientName}} ({{clientId}})</p>
        <p class="tw:text-sm tw:text-gray-600 tw:mb-0">{{ startDate | date : 'dd MMM yyyy'}} – {{ endDate | date : 'dd MMM yyyy'}}</p>
        @if (ownerName) {
          <p class="tw:text-sm tw:text-gray-600 tw:mb-3">Booking Owner / Referrer: {{ ownerName }}</p>
        }
      </div>

      <div class="tw:w-full tw:px-[15px]">
        <div class="flex-row">
          <div class="flex-column field">
            <label class="field__label" for="placementCustodian">Learner Administrator, Custodian, or Class teacher</label>
            <select id="placementCustodian" class="field__control" formControlName="placementCustodian" [compareWith]="compareCustodian">
              <option [ngValue]="null" disabled>Please select&hellip;</option>
              @for (custodian of custodianList; track custodian) {
                <option [ngValue]="custodian.userId">{{custodian.dropdownDisplay}}</option>
              }
            </select>
            @if (frmGroupMaintenance.get('placementCustodian').invalid && frmGroupMaintenance.get('placementCustodian').touched) {
              <span class="field__error">This is a required field</span>
            }
          </div>
        </div>
      </div>

      <div class="tw:w-full tw:px-[15px]">
        <ng-container *ngComponentOutlet="whoCanSee; inputs: { placementId: placementId }"></ng-container>
      </div>

      <div class="tw:w-full tw:px-[15px] tw:mt-auto tw:pt-4">
        <button type="button" class="btn btn-primary tw:mx-1" (click)="saveGroupMaintenance()">Save</button>
        <button type="button" class="btn btn-primary tw:mx-1 tw:float-right" (click)="close()">Close</button>
      </div>

    </div>
  </form>
</div>
